<template>
    <div class="change-password-view">
        <el-form :model="form" status-icon :rules="rules" ref="changePassword" label-width="120px" class="demo-ruleForm">
            <el-form-item label="Old Password" prop="oldPass">
                <el-input type="password" v-model="form.oldPass" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="Password" prop="pass">
                <el-input type="password" v-model="form.pass" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="Confirm" prop="confirmPass">
                <el-input type="password" v-model="form.confirmPass" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" :loading="loading" @click="submitForm('changePassword')">Submit</el-button>
                <el-button @click="resetData('changePassword')">Reset</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {generateHeader} from "@/misc/function.js";
    export default {
        data() {
            var validateOldPass = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('Please Enter Old Password'))
                } else {
                    callback()
                }
            };
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Please Enter New Password'));
                } else {
                    if (this.form.confirmPass !== '') {
                        this.$refs.changePassword.validateField('confirmPass');
                    }
                    callback();
                }
            };
            var validateConfirmPass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Please Enter new password again'));
                } else if (value !== this.form.pass) {
                    callback(new Error('New Password don\'t match!'));
                } else {
                    callback();
                }
            };
            return {
                loading: false,
                form: {
                    pass: '',
                    confirmPass: '',
                    oldPass: ''
                },
                rules: {
                    pass: [
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    confirmPass: [
                        { validator: validateConfirmPass, trigger: 'blur' }
                    ],
                    oldPass: [
                        { validator: validateOldPass, trigger: 'blur' }
                    ]
                }
            };
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true

                        this.$axios.post("auth/changePassword.php", this.form, {
                            headers: generateHeader("changePassword")
                        })
                        .then((response) => {
                            if(response.data.code == "204"){
                                this.$notify.success({
                                    title: 'Success',
                                    message: response.data.extra.message
                                });
                                this.resetData('changePassword')
                                localStorage.clear()
                                this.$router.push('/login')
                            }
                            else if (response.data.code == "401"){
                                this.$notify.info({
                                    title: 'Info',
                                    message: response.data.extra.message
                                });
                                localStorage.clear()
                                this.$router.push('/login')
                            }
                            else{
                                this.$notify.info({
                                    title: 'Info',
                                    message: response.data.extra.message
                                });
                            }
                            this.loading = false
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: 'Error',
                                message: error                   
                            });
                            this.loading = false
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetData(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>